const app = {
    state: {
        activeDepartment: {
            id: null
        }
    },
    mutations: {
        setActiveDepartment(state, data) {
            state.activeDepartment = data
        },
    }
}
export default app